export default __webpack_public_path__ + "static/media/PROCESSMETHOD_CASTING_SHELL.844c490a.png";